import React, { useRef } from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";
import "./KarteJaBadhteJaWidget.css";

const KarteJaBadhteJaWidget = () => {
    const data = useStaticQuery(graphql`
        query KJBJImgQuery {
            mobileImage: file(relativePath: { eq: "kjbj_mobile_safely.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
            mobileThumbImage: file(
                relativePath: { eq: "mobile_thumbnail_2x.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopThumbImage: file(
                relativePath: { eq: "web_thumbnail_2x.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    const sources = [
        {
            ...data.mobileImage.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];
    const thumbImgsources = [
        data.desktopThumbImage.childImageSharp.fluid,
        {
            ...data.mobileThumbImage.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];

    const LightboxRef = useRef(null);
    const YTRefVideo = useRef(null);
    const overlayRef = useRef(null);

    const revealVideo = (LightboxRef, YTRefVideo, overlayRef) => {
        var IframeSrc = YTRefVideo.current.src;
        YTRefVideo.current.src = IframeSrc + "&autoplay=1";
        LightboxRef.current.style.display = "block";
        overlayRef.current.style.display = "block";
    };

    const hideVideo = (LightboxRef, YTRefVideo, overlayRef) => {
        var IframeSrc = YTRefVideo.current.src;
        var cleaned = IframeSrc.replace("&autoplay=1", "");
        YTRefVideo.current.src = cleaned;
        LightboxRef.current.style.display = "none";
        overlayRef.current.style.display = "none";
    };

    return (
        <WidgetContainer stylesClass="never-stop">
            <div className="never-stop-widget">
                <div
                    className="never-stop-widget__video-container"
                    title="PhonePe - India’s Payments App"
                    onClick={() =>
                        revealVideo(LightboxRef, YTRefVideo, overlayRef)
                    }
                >
                    <Img
                        fluid={sources}
                        alt=""
                        imgStyle={{
                            height: "100%",
                            width: "100%",
                            objectFit: "cover",
                        }}
                        className="safetly-img"
                    />
                    <Img
                        fluid={thumbImgsources}
                        alt=""
                        imgStyle={{
                            height: "100%",
                            width: "100%",
                            objectFit: "cover",
                        }}
                    />
                </div>
                <div
                    class="lightbox"
                    ref={LightboxRef}
                    onClick={() =>
                        hideVideo(LightboxRef, YTRefVideo, overlayRef)
                    }
                >
                    <div
                        class="lightbox-container-overlay"
                        onClick={() =>
                            hideVideo(LightboxRef, YTRefVideo, overlayRef)
                        }
                        ref={overlayRef}
                    ></div>
                    <div class="lightbox-container">
                        <div class="lightbox-content">
                            <button
                                onClick={() =>
                                    hideVideo(
                                        LightboxRef,
                                        YTRefVideo,
                                        overlayRef
                                    )
                                }
                                class="lightbox-close"
                            >
                                Close | ✕
                            </button>
                            <div class="video-container">
                                <iframe
                                    ref={YTRefVideo}
                                    width="960"
                                    height="540"
                                    src="https://www.youtube.com/embed/LJFhihqQgkw?showinfo=0&rel=0"
                                    frameborder="0"
                                    allowfullscreen
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="never-stop-widget__content">
                    <div className="empty-div"></div>
                    <div>
                        Every day we wake up, learn to navigate life into 'the
                        new normal' and help each other to keep going - all this
                        with a smile behind our masks. This is our ode to
                        #Unstoppablelndia <br />
                        <span>#karteJaBadhteJa</span>
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};
export default KarteJaBadhteJaWidget;
